
export default {
  name: 'MoleculeTitleAndDescription'
}
